import React from "react";
import styles from "./ContactInquiries.module.css";

import Chevron from "Utils/Assets/SVGs/Chevron";
import Mail from "Utils/Assets/SVGs/Mail";
import Phone from "Utils/Assets/SVGs/Phone";
import { IContactInquiryCardProps } from "@model/contactus.model";

const ContactInquiryCard: React.FC<IContactInquiryCardProps> = ({
  inquiry,
  isOpen,
  onToggle,
  formatWhen,
  firstSentence,
  onOpenModal,
  onResolve,
}) => {
  const previewText = firstSentence(inquiry.message);

  return (
    <article
      className={styles.card}
      data-testid={`ci-card-${inquiry.id}`}
      onClick={onToggle}
    >
      <div className={styles.cardTop}>
        <div className={styles.avatar} aria-hidden>
          {inquiry.name?.[0]?.toUpperCase() || "?"}
        </div>

        <div className={styles.meta}>
          <div className={styles.subjectLine}>
            {inquiry.subject && <span>{inquiry.subject}</span>}
          </div>

          <div className={styles.nameRow}>
            <strong className={styles.name}>{inquiry.name}</strong>
            <span
              className={`${styles.status} ${inquiry.resolved ? styles.resolved : styles.unresolved
              }`}
              data-testid="ci-status"
            >
              {inquiry.resolved ? "Resolved" : "Unresolved"}
            </span>
            <span className={styles.when}>{formatWhen(inquiry.createdAt)}</span>
          </div>

          <div className={styles.contactLine}>
            {inquiry.email && (
              <a
                href={`mailto:${inquiry.email}`}
                className={styles.contactChip}
                onClick={(e) => e.stopPropagation()}
                data-testid="ci-email"
              >
                <Mail className={styles.contactIcon} />
                <span>{inquiry.email}</span>
              </a>
            )}
            {inquiry.phone && (
              <a
                href={`tel:${inquiry.phone}`}
                className={styles.contactChip}
                onClick={(e) => e.stopPropagation()}
                data-testid="ci-phone"
              >
                <Phone className={styles.contactIcon} />
                <span>{inquiry.phone}</span>
              </a>
            )}
          </div>

          {!isOpen && (
            <div className={styles.preview} data-testid="ci-preview">
              {previewText}
            </div>
          )}
        </div>

        <button
          type="button"
          className={styles.expandBtn}
          aria-label={isOpen ? "Collapse" : "Expand"}
          onClick={(e) => {
            e.stopPropagation();
            onToggle();
          }}
          data-testid="ci-expand"
        >
          <Chevron
            className={`${styles.chevIcon} ${isOpen ? styles.chevOpen : ""}`}
          />
        </button>
      </div>
      {isOpen && (
        <div className={styles.body} data-testid="ci-body">
          <p className={styles.fullMsg}>{inquiry.message}</p>

          {!inquiry.resolved && (
            <div className={styles.bodyActions}>
              {onResolve && (
                <button
                  type="button"
                  className={styles.resolveBtn}
                  onClick={(e) => {
                    e.stopPropagation();
                    onResolve();
                  }}
                  data-testid="ci-resolve"
                >
                  ✓ Resolve
                </button>
              )}

              {onOpenModal && (
                <button
                  type="button"
                  className={styles.secondaryBtn}
                  onClick={(e) => {
                    e.stopPropagation();
                    onOpenModal();
                  }}
                  data-testid="ci-open-modal"
                >
                  ↗ Reply
                </button>
              )}
            </div>
          )}
        </div>
      )}
      
    </article>
  );
};

export default ContactInquiryCard;
